import { useState } from "react"
import {
  TooltipButton,
  type TooltipButtonProps,
} from "@/v2-backoffice-client/components/button"
import TenantUpdateDialog from "@/v2-backoffice-client/tenant/update/TenantUpdateDialog"
import type { TenantFragment } from "@/v2-backoffice-client/tenant/__types__/tenant.fragment"

export type TenantUpdateButtonProps = Omit<
  TooltipButtonProps,
  "content" | "onClick"
> & {
  tenant: TenantFragment
}

function TenantUpdateButton(props: TenantUpdateButtonProps) {
  const { tenant, children, ...tooltipButtonProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <TooltipButton
        variant="ghost"
        size="tiny"
        iconSrc="pencil"
        content="Rename the team and set what a new member starts with."
        isSquare={!children}
        onClick={(e) => {
          e.stopPropagation()
          setIsOpen(true)
        }}
        {...tooltipButtonProps}
      >
        {children}
      </TooltipButton>

      <TenantUpdateDialog
        tenant={tenant}
        open={isOpen}
        onOpenChange={setIsOpen}
      />
    </>
  )
}

export default TenantUpdateButton
